// @flow

import * as React from "react"
import {connect} from "react-redux"
import ClassNames from "classnames"
import Modal from "react-modal"
import SearchItemListItem from "./search-item-list-item"
import type {SearchListItem, Dispatch} from "../types"

// isStandalone means: on the baby admin screen, not on the main dashboard
type Props = {
  keyName: string,
  +searchListItems: $ReadOnlyArray<SearchListItem>,
  +toggleds: $ReadOnlyArray<number>,
  +foundRemarksToggleds: $ReadOnlyArray<number>,
  +dispatch: Dispatch,
  +isStandalone: boolean,
}

class SearchItemList extends React.Component<Props> {
  static defaultProps = {
    isStandalone: false,
    key: "",
  }

  constructor(props: Props) {
    super(props)
    Modal.setAppElement("#app")
  }

  render() {
    const {
      searchListItems,
      toggleds,
      foundRemarksToggleds,
      isStandalone,
      keyName,
    } = this.props
    const className = ClassNames("search-item-list", {})
    return (
      <ul className={className}>
        {searchListItems.map((item) => (
          <SearchItemListItem
            key={`search-list-item-${keyName}-product-${item.productId}`}
            isToggled={toggleds.includes(item.productId)}
            foundRemarksToggleds={foundRemarksToggleds}
            searchListItem={item}
            isStandalone={isStandalone}
          />
        ))}
      </ul>
    )
  }
}

export default connect()(SearchItemList)
